import { apiSlice } from "../../../features/api/apiSlice";

function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}
function pickArr(res: any): any[] {
  const d = pick(res);
  return Array.isArray(d) ? d : [];
}

export const chairmanExamApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ── Results awaiting moderation ─────────────────────────────────────────
    chairmanGetResults: builder.query<any[], { dietId?: string; status?: string } | void>({
      query: (params) => {
        const q = new URLSearchParams();
        if ((params as any)?.dietId) q.set("diet_id", (params as any).dietId);
        if ((params as any)?.status) q.set("status", (params as any).status);
        const s = q.toString();
        return `/exam/chairman/results${s ? `?${s}` : ""}`;
      },
      transformResponse: (res: any) => pickArr(res),
      providesTags: [{ type: "ChairmanResults" as const, id: "LIST" }],
    }),

    // ── Publish a result batch ──────────────────────────────────────────────
    chairmanPublishResults: builder.mutation<any, string>({
      query: (id) => ({ url: `/exam/chairman/results/${id}/publish`, method: "POST" }),
      invalidatesTags: [{ type: "ChairmanResults" as const, id: "LIST" }],
    }),

    // ── Send back to chief for rework ───────────────────────────────────────
    chairmanRequestReview: builder.mutation<any, { id: string; comment: string }>({
      query: ({ id, comment }) => ({
        url: `/exam/chairman/results/${id}/review`,
        method: "POST",
        body: { comment },
      }),
      invalidatesTags: [{ type: "ChairmanResults" as const, id: "LIST" }],
    }),

    // ── Individual result records in a batch ───────────────────────────────
    chairmanGetBatchDetails: builder.query<any[], string>({
      query: (batchId) => `/exam/chairman/results/${batchId}/details`,
      transformResponse: (res: any) => pickArr(res),
      providesTags: (_, __, id) => [{ type: "ChairmanResults" as const, id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useChairmanGetResultsQuery,
  useChairmanPublishResultsMutation,
  useChairmanRequestReviewMutation,
  useChairmanGetBatchDetailsQuery,
} = chairmanExamApi;
